import { render, staticRenderFns } from "./AoRecruitsDataTable.vue?vue&type=template&id=e8c2cee8&"
import script from "./AoRecruitsDataTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AoRecruitsDataTable.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports